<template>
  <div class="public-main-content" ref="targetDiv">
    <div class="main-content">
      <h3>暖峰行动</h3>
      <div class="public-content">
        <div class="left-content">
          <p>峰学未来致力于打造一体化的人才培养及教育生态平台， 打通人才培养、升学规划及优质就业的绿色通道。
            为万千高中生和家长解决新高考选科、高中学业规划、志愿填报、大学学业规划、实习就业等各方面问题。
            我们积极主动承担社会责任，并为此开展了暖峰公益、带货助学等一系列活动。
          </p>
        </div>
        <div class="right-content">
          <span>
            <i>
              <count-to v-show="showCountService" ref="serviceCountTo" :startVal='0' :endVal='hopeMoney'
                :duration='3000' :decimals="2"></count-to>
            </i>
            万元</span>
          <h3>历史善款总数额</h3>
        </div>
      </div>
      <router-link target="_blank" to="publicWelfare">
        <el-button>查看更多</el-button>
      </router-link>
    </div>
  </div>
</template>

<script>
import CountTo from 'vue-count-to';
export default {
  name: "PublicIntroduce",
  data() {
    return {
      hopeMoney: 0,
      page: 1,
      size: 12,
      showCountService: false,
    }
  },
  components: {
    CountTo,
  },
  mounted() {

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5, // 当目标元素50%可见时触发回调
    };

    const observer = new IntersectionObserver(this.handleIntersection, options);
    observer.observe(this.$refs.targetDiv);
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.$http({
        method: 'get',
        url: '/api/v1/main_station/main/public/welfare/',
        params: {
          mold: 1,
          page: this.page,
          size: this.size
        },
        headers: {
          'AUTH-SYS': 'admin'
        },
      }).then(res => {
        this.hopeMoney = parseFloat((res.data.data.warm_money / 10000).toFixed(2));
      })
    },
    handleIntersection(entries) {
      entries.forEach(entry => {
        const serviceCountTo = this.$refs.serviceCountTo;
        if (entry.isIntersecting) {
          this.showCountService = true;
          if (serviceCountTo) {
            serviceCountTo.start();
          }
        }
      });
    },
  },
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'SourceHanSansCN';
  src: url('https://oss.fxwljy.com/attach/file1706509868982.otf');
}

@font-face {
  font-family: 'SourceHanSansCNBold';
  src: url('https://oss.fxwljy.com/attach/file1706509868791.otf');
}

.public-main-content {
  width: 100%;
  margin: 0 auto;
  background-image: url("../assets/img/nuanfeng-bg.jpg");
  background-size: cover;
  background-position: center;
  height: 810px;

  .main-content {
    width: 1200px;
    margin: 0 auto;
    padding-top: 120px;

    h3 {
      font-size: 40px;
      font-family: 'SourceHanSansCNBold Microsoft YaHei' !important;
      font-weight: bold;
      color: #0A0D0F;
      line-height: 60px;
      letter-spacing: 2px;
    }

    button {
      width: 140px;
      height: 52px;
      border-radius: 8px;
      border: 1px solid #434649;
      font-size: 18px;
      font-family: 'SourceHanSansCN Microsoft YaHei';
      font-weight: 400;
      color: #434649;
      margin-top: 70px;
      background-color: transparent;
    }

    .el-button:hover {
      background-color: #0086FF;
      color: #ffffff;
      border: none;
    }

    .el-button:focus {
      background-color: transparent;
      color: #434649;
    }

    .public-content {
      display: flex;
      /*align-items: center;*/
      justify-content: space-between;
      margin-top: 40px;
      height: 135px;

      .left-content {
        width: 798px;

        p {
          font-size: 18px;
          font-family: 'SourceHanSansCN Microsoft YaHei';
          font-weight: 400;
          color: #434649;
          line-height: 45px;
          letter-spacing: 1px;
          text-align: justify;
        }
      }

      .right-content {
        span {
          font-size: 16px;
          font-family: 'SourceHanSansCN Microsoft YaHei';
          font-weight: 400;
          color: #0A0D0F;
          line-height: 24px;

          i span {
            font-style: normal;
            font-size: 60px;
            font-family: 'numberFamily';
            color: #FF3939;
            line-height: 85px;
            font-weight: bold;
          }
        }

        h3 {
          font-size: 20px;
          font-family: 'SourceHanSansCN Microsoft YaHei';
          font-weight: 400;
          color: #434649;
          line-height: 30px;
          margin-top: 5px;
        }
      }
    }
  }
}
</style>